import { TiptapEditor } from "@circle-react-uikit/TipTap";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { ErrorBoundary } from "@/react/components/shared/ErrorPages/ErrorBoundary";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

import { messageTextClasses } from "./messageTextClasses";
import { StaticMessageBody } from "./StaticMessageBody";
import { canRenderStatically } from "./StaticMessageBody/canRenderStatically";

export interface TipTapMessageBodyProps {
  chatProps?: any;
  chatRoomAccessArr?: Array<any>;
  editedAt?: any;
  rich_text_body?: any;
  shouldScrollIntoView?: boolean;
  shouldShowPreviewBlocks?: boolean;
}

export const TipTapMessageBody = ({
  editedAt,
  shouldScrollIntoView = false,
  rich_text_body,
  chatRoomAccessArr,
  shouldShowPreviewBlocks = true,
  chatProps = {},
}: TipTapMessageBodyProps) => {
  if (!rich_text_body) {
    return null;
  }

  // Skip the ProseMirror editor entirely for the common case (plain text +
  // marks + mentions + entities). Anything richer falls back to the editor.
  const canRenderStatic = canRenderStatically({
    attachments: rich_text_body.attachments,
    body: rich_text_body.body,
    unfurlUrls: chatProps.unfurlUrls,
  });

  return (
    <ErrorBoundary
      renderFunc={() => (
        <Typography.LabelSm color="text-v2-danger">
          {t("messaging.message_error")}
        </Typography.LabelSm>
      )}
    >
      <div
        className={classNames(
          anchorClassNames("chat-message-word-wrap"),
          messageTextClasses,
        )}
        data-testid="message-text"
      >
        {canRenderStatic ? (
          <StaticMessageBody
            body={rich_text_body.body}
            editedAt={editedAt}
            sgidToObjectMap={rich_text_body.sgids_to_object_map}
          />
        ) : (
          <TiptapEditor
            editable={false}
            rich_text_body={rich_text_body}
            shouldScrollIntoView={shouldScrollIntoView}
            shouldRefetch
            editedAt={editedAt}
            chatRoomAccessArr={chatRoomAccessArr}
            shouldShowPreviewBlocks={shouldShowPreviewBlocks}
            chatProps={chatProps}
          />
        )}
      </div>
    </ErrorBoundary>
  );
};
